import { useState } from 'react'
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts'
import stringHelpers from '../../../utilities/stringHelpers'
import { AnalyticsSlider } from '../../shared/analyticsSlider'
import { vehicleAnalyticsChartColours } from '../../../utilities/constants'
const COLOUR_MAP = {
    "BLACK": "#2b2b2b",
    "GREY": "#9e9e9e",
    "WHITE": "#e0e0e0",
    "SILVER": "#bdbdbd",
    "BLUE": "#4169E1",
    "RED": "#E53935",
    "GREEN": "#43A047",
}

const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload?.length) return null
    const { name, value, payload: p } = payload[0]
    return (
        <div className="analytics-tooltip">
            <div className="analytics-tooltip-header">
                <span className="analytics-tooltip-dot" style={ { background: p.fill } } />
                <span className="analytics-tooltip-name">{ name }</span>
            </div>
            <span className="analytics-tooltip-value">{ stringHelpers.formatDecimal(value, 0) } vehicle{ value !== 1 ? "s" : "" } &nbsp;·&nbsp; { stringHelpers.formatDecimal(p.percent, 2) }%</span>
        </div>
    )
}

const getColour = (name, index) => COLOUR_MAP[name] ?? vehicleAnalyticsChartColours[index % vehicleAnalyticsChartColours.length]

export const VehicleColourPieChart = ({ breakdown }) => {
    const total = Object.values(breakdown).reduce((a, b) => a + b, 0)

    const sorted = Object.entries(breakdown)
        .map(([name, value]) => ({ name, value }))
        .sort((a, b) => b.value - a.value)

    const max = Math.max(2, sorted.length)
    const [limit, setLimit] = useState(Math.min(6, max))

    const limited = sorted.length > limit
        ? [...sorted.slice(0, limit), { name: "OTHER", value: sorted.slice(limit).reduce((s, d) => s + d.value, 0) }]
        : sorted

    const data = limited.map(({ name, value }) => ({ name, value, percent: (value / total) * 100 }))

    return (
        <div className="analytics-chart-card">
            <div className="analytics-chart-card-header mb-1">
                <p className="analytics-chart-title">Colour</p>
                <AnalyticsSlider label={ `Top ${limit}` } value={ limit } min={ 2 } max={ max } step={ 1 } onChange={ setLimit } />
            </div>
            <ResponsiveContainer width="100%" height={ 190 }>
                <PieChart>
                    <Pie data={ data } dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={ 80 } strokeWidth={ 0 }>
                        { data.map((entry, index) => (
                            <Cell key={ entry.name } fill={ getColour(entry.name, index) } />
                        )) }
                    </Pie>
                    <Tooltip content={ <CustomTooltip /> } />
                </PieChart>
            </ResponsiveContainer>
            <div className="analytics-legend">
                { data.map((entry, index) => (
                    <div key={ entry.name } className="analytics-legend-item">
                        <span className="analytics-legend-dot" style={ { background: getColour(entry.name, index) } } />
                        <span className="analytics-legend-label">{ entry.name }</span>
                        <span className="analytics-legend-percent">{ stringHelpers.formatDecimal(entry.percent, 2) }%</span>
                    </div>
                )) }
            </div>
        </div>
    )
}
